import type { ComponentProps } from "react"
import { forwardRef } from "react"

import { cn } from "@productlane/lib/src/browser"

type Props = ComponentProps<"svg">

export const FrontIcon = forwardRef<SVGSVGElement, Props>(
	({ className, ...props }, ref) => {
		return (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				xmlSpace="preserve"
				style={{
					//enableBackground: "new 0 0 1160.3 928",
				}}
				viewBox="0 0 1160.3 928"
				ref={ref}
				{...props}
				className={cn("", className)}
			>
				<path
					d="M326.8 222.5c0-66.5 53.9-120.5 120.5-120.5h386.3v171.4c0 33.3-27 60.2-60.2 60.2h-157c-32 0-57.9 25.9-57.9 57.9v374.2c0 33.3-27 60.2-60.2 60.2H326.8V222.5z"
					style={{
						fill: "#001b38",
					}}
				/>
				<linearGradient
					id="a"
					x1={309.418}
					x2={546.218}
					y1={-290.488}
					y2={-525.658}
					gradientTransform="rotate(90 122.236 91.78)"
					gradientUnits="userSpaceOnUse"
				>
					<stop
						offset={0}
						style={{
							stopColor: "#ff0057",
							stopOpacity: 0.16,
						}}
					/>
					<stop
						offset={0.86}
						style={{
							stopColor: "#ff0057",
						}}
					/>
				</linearGradient>
				<circle
					cx={617.8}
					cy={393}
					r={156.4}
					style={{
						fill: "url(#a)",
					}}
				/>
				<linearGradient
					id="b"
					x1={309.418}
					x2={546.218}
					y1={-290.488}
					y2={-525.658}
					gradientTransform="rotate(90 122.236 91.78)"
					gradientUnits="userSpaceOnUse"
				>
					<stop
						offset={0}
						style={{
							stopColor: "#ff0057",
							stopOpacity: 0.16,
						}}
					/>
					<stop
						offset={0.86}
						style={{
							stopColor: "#ff0057",
						}}
					/>
				</linearGradient>
				<circle
					cx={617.8}
					cy={393}
					r={156.4}
					style={{
						opacity: 0.5,
						fill: "url(#b)",
						//enableBackground: "new",
					}}
				/>
			</svg>
		)
	},
)
